import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import DocumentsPage from "./pages/DocumentsPage";
import DocumentDetailPage from "./pages/DocumentDetailPage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Seed data on app load
const SeedData = () => {
  useEffect(() => {
    const seed = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        // Already seeded or error
      }
    };
    seed();
  }, []);
  return null;
};

// Protected route for admin/superadmin
const AdminRoute = ({ children }) => {
  const { isAdmin, loading } = useAuth();
  if (loading) return null;
  return isAdmin ? children : <Navigate to="/dashboard" replace />;
};

// Protected route for superadmin only
const SuperadminRoute = ({ children }) => {
  const { isSuperadmin, loading } = useAuth();
  if (loading) return null;
  return isSuperadmin ? children : <Navigate to="/dashboard" replace />;
};

// Redirect based on role
const RoleBasedRedirect = () => {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={isAdmin ? "/dashboard" : "/documents"} replace />;
};

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <SeedData />
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<Layout />}>
                <Route index element={<RoleBasedRedirect />} />
                <Route path="dashboard" element={<AdminRoute><DashboardPage /></AdminRoute>} />
                <Route path="documents" element={<DocumentsPage />} />
                <Route path="documents/:id" element={<DocumentDetailPage />} />
                <Route path="users" element={<AdminRoute><UsersPage /></AdminRoute>} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>
              <Route path="*" element={<RoleBasedRedirect />} />
            </Routes>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
